/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();



  $(document).ready(function(){
    $('.slider-show-nav').first().addClass('active_argolf');
     $('.collection_button_nav').first().addClass('active_argolf_buttons');
    $('.collection_button_nav').click(function(){
         var cln_btn_id = $(this).attr('btn-id');
          $('.collection_button_nav').removeClass('active_argolf_buttons');
          $(this).addClass('active_argolf_buttons');
          $('.slider-show-nav').each(function(){
            var product_btn_id =$(this).find('.slider-mobile-gutter').attr('btn-id');
                 if(product_btn_id == cln_btn_id){
                   $(this).show();
                 }
              else{
                   $(this).hide();
              }
          });
    });
    
  });
 
   
     $(".menu__item").on("mouseout", function () {
         $(".theme__header").css("background-color", "#00000000");
    });
     $( ".menu__item").on("mouseover", function () {
       $(".theme__header").css("background-color", "black");
    });
    




